import React from "react"
import MicrosoftStartups from "./Partnership/MicroSoftStartups"

export default function Partnership() {
    return <>
        <MicrosoftStartups />
    </>
}